<template>
  <div class="map">
    <span class="goBack" @click="goBack" v-if="zone !== 'world'">返回 ></span>
    <div class="map-container" ref="mapContainer"></div>
  </div>
</template>

<script>
import echarts from '../../../../public/js/echart/echarts.min2.js'
import echartsJson from '../../../../public/js/echart/customed.json'
import { worldJson } from './initMap.js'
export default {
  props: {
    config: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      locationIcon: require('@/assets/images/bigScreen/location.png'),
      myChart: null,
      zone: 'world'
    }
  },
  mounted() {
    worldJson(this.zone, echarts, () => {
       echarts.registerTheme('customed', echartsJson)
      this.initMapConfig()
      this.$nextTick(() => {
        // 监听全屏事件
        window.addEventListener('resize', () => {
          if (this.myChart) {
            setTimeout(() => {
              this.myChart.resize()
            }, 60)
          }
        })
      })
    })
   
  },
  methods: {
    initMapConfig(type = 'world') {
      let that = this
      let myChart = echarts.init(this.$refs.mapContainer, 'customed')
      myChart.setOption(
        // 初始化echarts配置
        {
          tooltip: {
            alwaysShowContent: true, // 不自动隐藏
            // enterable: true, // 鼠标可移入
            confine: true,
            triggerOn: 'mousemove',
            padding: 0,
            borderColor: 'transparent',
            backgroundColor: 'transparent',
            extraCssText: 'z-index: 10',
            formatter: (params, ticket, callback) => {
              let content = ''
              if (this.config.formatter.length) {
                for (let i = 0; i < this.config.formatter.length; i++) {
                  let num = (params.data && params.data.data && params.data.data[this.config.formatter[i].key]) || 0
                  content += ` <div class="tooltips-item">
                  <span class="item-name">${this.config.formatter[i].name}</span>
                  <span class="item-value">${this.config.formatter[i].unit || ''}${
                    this.config.formatter[i].unit ? Number(num).toFixed(2) : num
                  }</span>
                </div>`
                }
              }
              // <img src="${this.locationIcon}"/>
              return `
            <div class="tooltips-container">
              <div class="tooltips-head">
                <span>${params.name}</span></div>
              <div class="tooltips-content">
               ${content}
              </div>
            </div>
          `
            }
          },
          series: [
            {
              type: 'map', // 散点图
              map: type,
              data: [],
              itemStyle: {
                // 设置国家填充色和边界色
                normal: {
                  areaColor: '#4b4b4b',
                  borderWidth: 0.4,
                  borderColor: '#2d2d30'
                },
                emphasis: {
                  areaColor: '#ffc000',
                  borderWidth: 0.4,
                  borderColor: '#2d2d30'
                }
              },
              selectedMode: false,
              layoutCenter: ['50%', '50%'], // 地图中心位置，layoutCenter和layoutSize确保地图比例不变
              layoutSize: (1200 * (window.innerWidth - 240)) / 1920, // 地图宽度
              roam: 'move'
            }
          ]
        },
        true
      )
      myChart.on('click', function(params) {
        console.log(params, 'cesdfsdf')
        let result = worldJson(params.name, echarts)
        if (result === 0) {
          return
        }
       
        that.myChart = null
        that.zone = params.name
        that.initMapConfig(params.name)
        that.myChart.resize()
        that.$emit('changeZone', params)
      })
    console.log('单前图库', myChart)
      this.myChart = myChart
    },
    goBack() {
      this.zone = 'world'
      worldJson('world', echarts)
      this.initMapConfig('world')
      this.$emit('changeZone', { name: 'world' })
    }
  }
}
</script>

<style lang="scss" scoped>
.map {
  position: absolute;
  right: 1vw;
  top: 30vh;
}
.goBack {
  position: absolute;
  color: #fff;
  right: 1vw;
  cursor: pointer;
  z-index: 6;
}
.map-container {
  width: 58vw;
  height: 60vh;
}
::v-deep {
  .el-loading-mask {
    background-color: rgba(255, 255, 255, 0.01);
  }
  .tooltips-container {
    padding: 20px;
    width: 173px;
    background: linear-gradient(180deg, #4d4d53 0%, #37373b 100%);
    border-radius: 6px;
    .tooltips-head {
      font-size: 14px;
      color: #ffd74f;
      font-weight: bold;
      margin-bottom: 20px;
      // display: flex;
      // align-items: center;
      // justify-content: center;

      // img {
      //   width: 10px;
      //   margin-right: 5px;
      // }
    }

    .tooltips-content {
      // border: 1px solid rgba(255, 255, 255, 0.3);
      // border-radius: 5px;
      // background: rgba(0, 0, 0, 0.38);
      // box-shadow: rgba(0, 0, 0, 0.56) 0 0 5px;

      .tooltips-item {
        min-width: 110px;
        font-size: 12px;
        // line-height: 1.5;
        // padding: 0 5px;
        // background: rgba(0, 0, 0, 0.6);
        // margin-bottom: 6px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: #fff;

        // &:last-child {
        //   margin-bottom: 0;
        // }

        // .item-value {
        //   color: #ffc000;
        // }
      }
      .tooltips-item + .tooltips-item {
        margin-top: 16px;
      }
    }
  }
}
</style>
